import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Lenis from "lenis";

gsap.registerPlugin(ScrollTrigger);

class Scroller {
  lenis = null;

  setScroll(callback) {
    this.lenis = new Lenis({
      autoRaf: false,
      duration: 1.1,
      lerp: 0.15,
    });
    this.lenis.on("scroll", (e) => {
      ScrollTrigger.update();
      callback(e);
    });
    gsap.ticker.lagSmoothing(0);
    gsap.ticker.add((time) => {
      this.lenis?.raf(time * 1000);
    });
  }
  destroyScroll() {
    if (this.lenis) this.lenis.destroy();
  }
}

export const scroller = new Scroller();
